<template>
  <div>
    <v-form
      ref="signUpForm"
      @submit.prevent="submitForm"
      :errorMessages="errors.detail"
      lazy-validation
      v-if="!signUpSuccessful"
    >
      <v-card-title class="headline" primary-title>Sign Up</v-card-title>
      <v-card-text>
        <v-alert
          dense
          outlined
          type="error"
          v-if="errors.detail"
          v-html="errors.detail"
        ></v-alert>
        <v-text-field
          v-model="firstName"
          prepend-icon="mdi-account"
          name="first_name"
          label="First Name"
          type="text"
          :outlined="outlined"
          :dense="dense"
          :rules="nameRules"
          :errorMessages="errors.firstName"
        ></v-text-field>
        <v-text-field
          v-model="lastName"
          prepend-icon="mdi-account"
          name="last_name"
          label="Last Name"
          type="text"
          :outlined="outlined"
          :dense="dense"
          :rules="nameRules"
          :errorMessages="errors.lasName"
        ></v-text-field>
        <v-text-field
          v-model="username"
          prepend-icon="mdi-account"
          name="email"
          label="Email"
          type="text"
          :outlined="outlined"
          :dense="dense"
          :rules="emailRules"
          :errorMessages="errors.username"
        ></v-text-field>
        <v-text-field
          v-model="password"
          id="password"
          prepend-icon="mdi-lock"
          name="password"
          label="Password"
          type="password"
          :outlined="outlined"
          :dense="dense"
          :rules="passwordRules"
          :errorMessages="errors.password"
          @change="$refs.signUpForm.validate()"
        ></v-text-field>
        <v-text-field
          v-model="passwordConfirm"
          id="passwordConfirm"
          prepend-icon="mdi-lock"
          name="passwordConfirm"
          label="Confirm Password"
          type="password"
          :outlined="outlined"
          :dense="dense"
          :rules="passwordRules"
          :errorMessages="errors.password"
          @change="$refs.signUpForm.validate()"
        ></v-text-field>
      </v-card-text>
      <v-card-text class="py-0">
        <v-textarea
          v-model="termsOfUse"
          class="terms-of-use-text-area"
          readonly
          outlined
          @scroll="onTermsScroll"
          rows="12"
          no-resize
          :rules="tosRules"
          persistent-hint
        ></v-textarea>
      </v-card-text>
      <v-card-text class="text-subtitle-1 py-1">
        By signing up to use this website, in addition to agreeing to our above stated terms of service, you agree with our <privacy-policy-dialog />.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          color="primary"
          :disabled="submitted"
          :block="blockButton"
          :text="textButton"
        >
          Sign Up
        </v-btn>
      </v-card-actions>
    </v-form>
    <div v-else>
      <v-card-title>Registration Successful</v-card-title>
      <v-card-text
        >Please check your email for a link to activate your
        account.</v-card-text
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PrivacyPolicyDialog from "./PrivacyPolicyDialog.vue";
import { fieldRequired, maxLength } from '@/form-rules/'

import TERMS from "@/assets/terms-and-conditions";

export default {
  components: { PrivacyPolicyDialog },
  name: "SignUpForm",
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    blockButton: {
      type: Boolean,
      default: false,
    },
    textButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      username: "",
      password: "",
      firstName: "",
      lastName: "",
      passwordConfirm: "",
      submitted: false,
      errors: {},

      termsOfUse: TERMS,
      tosRead: false,
      tosRules: [
        v => !!v && !!this.tosRead || 'You must scroll to the end of the terms to continue.',
      ],
      nameRules: [
        fieldRequired(), maxLength(255)
      ],
      emailRules: [
        (value) => !!value || "Email is required.",
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },

      ],
      passwordRules: [
        (value) => !!value || "Password is required.",
        (value) => {
          if (
            value != "" &&
            this.password != "" &&
            this.passwordConfirm != ""
          ) {
            return (
              this.password === this.passwordConfirm || "Passwords must match."
            );
          }
          return true;
        },
      ],
    };
  },
  computed: {
    nextPath() {
      if ("next" in this.$route.query) {
        return this.$route.query.next;
      } else {
        return "/dashboard";
      }
    },
    signUpSuccessful() {
      return this.$store.state.auth.signUpSuccessful;
    },
    signUpEmail() {
      return this.$store.state.auth.signUpEmail;
    },
  },
  methods: {
    ...mapActions("auth", ["signUp", "getProfile"]),
    submitForm() {
      const valid = this.$refs.signUpForm.validate();
      if (valid) {
        this.signUp({
          username: this.username,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName
        });
      }
    },
    onTermsScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.tosRead = true;
        this.$refs.signUpForm.validate();
      }
    },
  },
};
</script>

<style></style>
